<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="用户名">
              <a-input placeholder="请输入用户名" v-model="queryParam.name"></a-input>
            </a-form-item>
          </a-col>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <a-form-item label="性别">
              <j-dict-select-tag dictCode="sex" placeholder="请选择性别" v-model="queryParam.sex" />
            </a-form-item>
          </a-col>
          <template v-if="toggleSearchStatus">
            <a-col :lg="7" :md="8" :sm="24" :xl="6">
              <a-form-item label="生日">
                <j-date placeholder="请选择生日" v-model="queryParam.birthday"></j-date>
              </a-form-item>
            </a-col>
            <a-col :lg="7" :md="8" :sm="24" :xl="6">
              <a-form-item label="用户编码">
                <a-input placeholder="请输入用户编码" v-model="queryParam.userCode"></a-input>
              </a-form-item>
            </a-col>
            <a-col :lg="7" :md="8" :sm="24" :xl="6">
              <a-form-item label="城市">
                <j-area-linkage placeholder="请选择省市区" type="cascader" v-model="queryParam.chegnshi" />
              </a-form-item>
            </a-col>
            <a-col :lg="7" :md="8" :sm="24" :xl="6">
              <a-form-item label="checkbox">
                <j-dict-select-tag dictCode="sex" placeholder="请选择checkbox" v-model="queryParam.ceck" />
              </a-form-item>
            </a-col>
            <a-col :lg="7" :md="8" :sm="24" :xl="6">
              <a-form-item label="下拉多选">
                <j-multi-select-tag dictCode="sex" placeholder="请选择下拉多选" v-model="queryParam.xiamuti" />
              </a-form-item>
            </a-col>
            <a-col :lg="7" :md="8" :sm="24" :xl="6">
              <a-form-item label="搜索下拉">
                <j-search-select-tag
                  dict="sys_role,role_name,role_code"
                  placeholder="请选择搜索下拉"
                  v-model="queryParam.searchSel"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :lg="7" :md="8" :sm="24" :xl="6">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('测试用户表')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="pcaSlot" slot-scope="text">
          <div>{{ getPcaText(text) }}</div>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import { filterMultiDictText } from '@/components/dict/JDictSelectUtil'
  import Area from '@/components/_util/Area'

  export default {
    name: 'TestDemoList',
    mixins: [JeecgListMixin, mixinDevice],
    components: {
    },
    data () {
      return {
        description: '测试用户表管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },
          {
            title: '用户名',
            align: "center",
            sorter: true,
            dataIndex: 'name'
          },
          {
            title: '性别',
            align: "center",
            sorter: true,
            dataIndex: 'sex_dictText'
          },
          {
            title: '年龄',
            align: "center",
            dataIndex: 'age'
          },
          {
            title: '描述',
            align: "center",
            dataIndex: 'descc',
            scopedSlots: { customRender: 'htmlSlot' }
          },
          {
            title: '生日',
            align: "center",
            dataIndex: 'birthday',
            customRender: function (text) {
              return !text ? "" : (text.length > 10 ? text.substr(0, 10) : text)
            }
          },
          {
            title: '头像',
            align: "center",
            dataIndex: 'topPic',
            scopedSlots: { customRender: 'imgSlot' }
          },
          {
            title: '附件',
            align: "center",
            dataIndex: 'fileKk',
            scopedSlots: { customRender: 'fileSlot' }
          },
          {
            title: '城市',
            align: "center",
            dataIndex: 'chegnshi',
            scopedSlots: { customRender: 'pcaSlot' }
          },
          {
            title: '弹窗',
            align: "center",
            dataIndex: 'pop'
          },
          {
            title: 'checkbox',
            align: "center",
            dataIndex: 'ceck_dictText'
          },
          {
            title: '下拉多选',
            align: "center",
            dataIndex: 'xiamuti_dictText'
          },
          {
            title: '搜索下拉',
            align: "center",
            dataIndex: 'searchSel_dictText'
          },
          {
            title: '下拉字典表',
            align: "center",
            dataIndex: 'selTable_dictText'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/test.demo/testDemo/list",
          delete: "/test.demo/testDemo/delete",
          deleteBatch: "/test.demo/testDemo/deleteBatch",
          exportXlsUrl: "/test.demo/testDemo/exportXls",
          importExcelUrl: "test.demo/testDemo/importExcel",

        },
        dictOptions: {},
        pcaData: '',
        superFieldList: [],
      }
    },
    created () {
      this.pcaData = new Area()
      this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      getPcaText (code) {
        return this.pcaData.getText(code);
      },
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'id', text: '主键', dictCode: '' })
        fieldList.push({ type: 'string', value: 'name', text: '用户名', dictCode: '' })
        fieldList.push({ type: 'string', value: 'sex', text: '性别', dictCode: 'sex' })
        fieldList.push({ type: 'int', value: 'age', text: '年龄', dictCode: '' })
        fieldList.push({ type: 'string', value: 'descc', text: '描述', dictCode: '' })
        fieldList.push({ type: 'date', value: 'birthday', text: '生日' })
        fieldList.push({ type: 'string', value: 'userCode', text: '用户编码', dictCode: '' })
        fieldList.push({ type: 'string', value: 'topPic', text: '头像', dictCode: '' })
        fieldList.push({ type: 'string', value: 'fileKk', text: '附件', dictCode: '' })
        fieldList.push({ type: 'pca', value: 'chegnshi', text: '城市' })
        fieldList.push({ type: 'string', value: 'pop', text: '弹窗', dictCode: '' })
        fieldList.push({ type: 'string', value: 'ceck', text: 'checkbox', dictCode: 'sex' })
        fieldList.push({ type: 'list_multi', value: 'xiamuti', text: '下拉多选', dictTable: '', dictText: '', dictCode: 'sex' })
        fieldList.push({ type: 'sel_search', value: 'searchSel', text: '搜索下拉', dictTable: 'sys_role', dictText: 'role_name', dictCode: 'role_code' })
        fieldList.push({ type: 'sel_search', value: 'selTable', text: '下拉字典表', dictTable: 'sys_user', dictText: 'realname', dictCode: 'username' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>